import { NewPatientForm } from "@/constants/provider/patient/add-new-patient/add-new-patient-form";
import { useNavigate, useParams } from "react-router-dom";
import { useGetPatient } from "../../../../queries/use-get-patient-uuid";
import UpsertPatientForm from "./UpsertPatientForm";
import ElevatedPaper from "../../../../components/ElevatedPaper";
import {
  DEFAULT_UUID_NAME_LIST,
  transformMultiSelectFrontEndVal,
} from "../../../../utils/utils";

const EditPatient = () => {
  const params = useParams();

  const { data: patientsData } = useGetPatient(params?.patientId);
  const navigate = useNavigate();

  // NewPatientForm declares the patient fields required; a record loaded for
  // edit can legitimately be missing any of them.
  const transFormData = {
    ...patientsData,
    languages: transformMultiSelectFrontEndVal(
      DEFAULT_UUID_NAME_LIST,
      patientsData?.languages
    ),
  } as NewPatientForm;

  return (
    <ElevatedPaper>
      <UpsertPatientForm
        prefillValues={transFormData}
        onCancel={() => navigate(-1)}
        closeDrawer={(id) => {
          navigate(
            `/app/provider/scheduling/appointment?openCheckIn=true&patientId=${id}`
          );
        }}
      />
    </ElevatedPaper>
  );
};

export default EditPatient;
